import { makeStyles } from "@mui/styles";
const styles = makeStyles(theme => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  }
}));

export default styles;